module.exports = __webpack_public_path__ + "img/17.984f3ca3.jpg";